define((require) => {
    "use strict";

    var Class                           = require("shared/util/Class"),
        _                               = require("underscore"),
        YouTubeImageCollectionView      = require("ui/assets/youtube/YouTubeImageCollectionView"),
        YouTubeImageCollection          = require("ui/assets/youtube/YouTubeImageCollection"),
        YouTubeImageModel               = require("ui/assets/youtube/YouTubeImageModel");

    function mapYouTubeModel(data) {
        var snippet = data.snippet;

        return {
            name: snippet.title,
            description: snippet.description,
            videoID: data.id,
            channelID: snippet.channelId,
            thumbnailUrl: snippet.thumbnails.medium.url,
            duration: data.contentDetails.duration
        };
    }

    return Class.extend({}, {

        toCollectionView: function(videos) {
            var collection = new YouTubeImageCollection();

            _.each(videos, (video) => {
                collection.push(new YouTubeImageModel(mapYouTubeModel(video)));
            });

            return new YouTubeImageCollectionView({
                collection: collection,
                itemViewOptions: {
                    showTooltips: true,
                    showImageInfo: true,
                    dropTargetSize: "large",
                    draggable: true
                }
            });
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/youtubeWidget/YouTubeUtil.js